import { FocusEventHandler, forwardRef } from 'react';
import AutocompleteSeeAll from './parts/AutocompleteSeeAll';
import AutocompleteCategory from './parts/AutocompleteCategory';
import { Autocomplete, SearchConfig } from '../SearchBarProps';

import './SearchResults.scss';

type SearchResultsProps = {
	searchInput: string;
	searchResults: Autocomplete[];
	searchConfig: SearchConfig;
	selectedId: string;
	onBlur: FocusEventHandler<HTMLDivElement>;
	display: boolean;
};

const SearchResults = forwardRef<HTMLDivElement, SearchResultsProps>(
	(
		{ searchInput, searchResults, searchConfig, selectedId, onBlur, display },
		ref
	) => {
		return (
			<div className="search-results-main-nav" ref={ref} onBlur={onBlur}>
				<div id="mainNavSearchResults">
					{!!searchResults.length && (
						<ul
							className={`autocomplete ${display ? '' : 'display-none'}`}
							tabIndex={-1}
						>
							{Object.entries(searchConfig.categories).map(
								([category, categoryConfig]) => {
									const resultsByCategory = searchResults.filter(
										(result) => result.category === category
									);

									return (
										<AutocompleteCategory
											searchInput={searchInput}
											category={category}
											categoryConfig={categoryConfig}
											resultsByCategory={resultsByCategory}
											seeAllLabel={searchConfig.seeAllLabel}
											selectedId={selectedId}
											key={`${category}-${searchInput}`}
										/>
									);
								}
							)}
							<AutocompleteSeeAll
								searchInput={searchInput}
								searchConfig={searchConfig}
							/>
						</ul>
					)}
				</div>
			</div>
		);
	}
);

SearchResults.displayName = 'SearchResults';

export default SearchResults;
